import { CoreGetApiLocation } from '@neustar/core-ui';

export const SESSION_URL = CoreGetApiLocation('config');
export const FEDERATION_URL: string = (window as any).__COREUIENV__['FEDERATION_SERVICE_API'];
export const TRAFFIC_URL: string = (window as any).__COREUIENV__['TRAFFIC_SERVICE_API'];
